"use client"

import { CourseWithMeta, isPremiumCourse } from "../types"
import { Carousel } from "./Carousel"
import { Recording } from "./Recording"

interface Props {
    courses: Record<string, CourseWithMeta<number>>
    priority?: boolean
    title?: string
    description?: string
}

export function CourseRecordingsCarousel({ courses, priority = false, title, description }: Props) {
    const premiumCourses = Object.fromEntries(
        Object.entries(courses).filter(([, course]) => isPremiumCourse(course))
    ) as Record<string, CourseWithMeta<number>>

    return (
        <Carousel<CourseWithMeta<number>>
            href="/academy/course-recordings"
            courses={premiumCourses}
            title={title ?? "Course Recordings"}
            template={(slug, course, priority) => (
                <Recording key={slug} course={course} slug={slug} priority={priority} />
            )}
            description={description ?? "Watch recordings of our past courses without delay."}
            priority={priority}
        />
    )
}
